import React, { useState } from "react";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { QuoteModal } from "@/components/QuoteModal";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [formType, setFormType] = useState('individual');

  const handleCotizarClick = (type = 'individual') => {
    setFormType(type);
    setIsQuoteModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header onCotizarClick={() => handleCotizarClick('individual')} />
      <main>
        <Hero onCotizarClick={handleCotizarClick} />
        <Services onCotizarClick={handleCotizarClick} />
        <About />
        <Contact onCotizarClick={() => handleCotizarClick('individual')} />
      </main>
      <Footer />
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)}
        formType={formType}
      />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
